/**
 * lab-pdp.js — Lab Effects Product Detail Page
 * Gallery · Variants · ATC · Sticky bar · Slide-ups · Accordions · Related carousel
 */
(function () {
  'use strict';

  /* ---- Category color system ---- */
  var LE_CATEGORY = {
    cdt:    { color: '#60B050', deep: '#3d8a36', soft: '#e7f0df' },
    blend:  { color: '#1AA0A6', deep: '#117a80', soft: '#d9f0f1' },
    bdt:    { color: '#3FA9CE', deep: '#2b87a8', soft: '#e0f1f8' },
    aroma:  { color: '#DAA423', deep: '#b6851a', soft: '#f6ead0' },
    base:   { color: '#5E7C84', deep: '#46606a', soft: '#e3e9ea' },
    flavor: { color: '#B26FB0', deep: '#8e519d', soft: '#f1e3f1' }
  };

  /* ============================================================
     GALLERY
     ============================================================ */
  // The gallery engine lives in assets/le-pdp-gallery.js (window.LE_initGallery),
  // shared with the merged PDP so both galleries behave identically. That file is
  // loaded before this one by sections/le-pdp-hero.liquid and self-initialises;
  // this shim only exists so the init list below keeps reading the same.
  function initGallery() {
    if (typeof window.LE_initGallery === 'function') window.LE_initGallery();
  }

  /* ============================================================
     VARIANT SELECTION
     ============================================================ */
  function initVariantSelector() {
    var form = document.getElementById('le-pdp-form');
    if (!form) return;

    var data = window.LE_PDP;
    if (!data || !data.variants) return;

    var variantIdInput = document.getElementById('le-pdp-variant-id');
    var priceEl = document.getElementById('le-pdp-price');
    var compareEl = document.getElementById('le-pdp-compare');
    var offBadgeEl = document.getElementById('le-pdp-off-badge');
    var stickyPriceEl = document.getElementById('le-pdp-sticky-price');

    var selectedOptions = {};
    // Seed from the initially selected variant
    if (data.selectedVariant) {
      data.selectedVariant.selectedOptions.forEach(function (opt) {
        selectedOptions[opt.name] = opt.value;
      });
    }

    // The non-size "primary" option (Plant Source, Choice, etc.) drives the chips.
    var primaryChip = document.querySelector('[data-plant-source]');
    var primaryName = (primaryChip && primaryChip.dataset.optionName) || 'Plant Source';
    // The size option's real name (e.g. "Size", "Volume", "Sample Size").
    var sizeBtn0 = document.querySelector('[data-size-option]');
    var sizeName = (sizeBtn0 && sizeBtn0.dataset.sizeName) || 'Size';

    function findVariant() {
      return data.variants.find(function (v) {
        return v.selectedOptions.every(function (opt) {
          return selectedOptions[opt.name] === opt.value;
        });
      });
    }

    function updateVariant() {
      var variant = findVariant();
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;

      var price = variant.price;
      var compare = variant.compareAtPrice;
      if (priceEl) priceEl.textContent = formatMoney(price);
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(price);
      if (compareEl) {
        if (compare && compare > price) {
          compareEl.textContent = formatMoney(compare);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (offBadgeEl) {
        if (compare && compare > price) {
          var pct = Math.round((1 - price / compare) * 100);
          offBadgeEl.textContent = pct + '% OFF';
          offBadgeEl.style.display = '';
        } else {
          offBadgeEl.style.display = 'none';
        }
      }
      updatePerUnit(variant);
      // Update URL without reload
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // Sync sticky size label + dropup active state
      var sizeTrigger = document.getElementById('le-sticky-size-trigger');
      var sizeLabel = document.getElementById('le-sticky-size-label');
      if (sizeTrigger && sizeLabel) {
        var sizeOptName = sizeTrigger.dataset.sizeOpt;
        var sizeVal = sizeOptName ? selectedOptions[sizeOptName] : null;
        if (sizeVal) sizeLabel.textContent = sizeVal;
      }
      var dropup = document.getElementById('le-sticky-dropup');
      if (dropup && sizeTrigger) {
        var sOpt = sizeTrigger.dataset.sizeOpt;
        var curVal = sOpt ? selectedOptions[sOpt] : null;
        dropup.querySelectorAll('[data-size-option]').forEach(function (b) {
          b.classList.toggle('le-sticky-dropup__size--active', b.dataset.sizeOption === curVal);
        });
      }
    }

    // Find the variant for a given primary-option + Size pair.
    function variantForPair(primaryVal, size) {
      return data.variants.find(function (v) {
        var pv = null, sz = null;
        v.selectedOptions.forEach(function (o) {
          if (o.name === primaryName) pv = o.value;
          if (o.name === sizeName) sz = o.value;
        });
        return pv === primaryVal && sz === size;
      });
    }

    // Re-price the size buttons (main grid + sticky dropup) for the currently
    // selected primary option, so prices track the chosen variant set.
    function refreshSizePrices() {
      var plant = selectedOptions[primaryName];
      if (plant == null) return;
      document.querySelectorAll('.le-pdp-size-btn[data-size-option]').forEach(function (btn) {
        var el = btn.querySelector('.le-pdp-size-btn__price');
        var v = variantForPair(plant, btn.dataset.sizeOption);
        if (el && v) el.textContent = formatMoney(v.price);
      });
      document.querySelectorAll('.le-sticky-dropup__size[data-size-option]').forEach(function (btn) {
        var el = btn.querySelector('.le-sticky-dropup__size-price');
        var v = variantForPair(plant, btn.dataset.sizeOption);
        if (el && v) el.textContent = formatMoney(v.price);
      });
    }

    // Broadcast the selected primary option (Plant Source) so other PDP sections
    // — e.g. the docs panel + "Made with" profile in le-pdp-story — can react.
    function broadcastPrimary() {
      document.dispatchEvent(new CustomEvent('le:plant-source', {
        detail: { option: primaryName, value: selectedOptions[primaryName] || '' }
      }));
    }

    // Plant Source chips
    document.querySelectorAll('[data-plant-source]').forEach(function (chip) {
      if (chip.dataset.interactive === 'false') return;
      chip.addEventListener('click', function () {
        selectedOptions[chip.dataset.optionName || primaryName] = chip.dataset.plantSource;
        document.querySelectorAll('[data-plant-source]').forEach(function (c) {
          c.dataset.active = (c.dataset.plantSource === chip.dataset.plantSource) ? 'true' : 'false';
        });
        updateVariant();
        refreshSizePrices();
        broadcastPrimary();
      });
    });

    // Size buttons
    document.querySelectorAll('[data-size-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectedOptions[sizeName] = btn.dataset.sizeOption;
        document.querySelectorAll('[data-size-option]').forEach(function (b) {
          b.classList.toggle('le-pdp-size-btn--active', b.dataset.sizeOption === selectedOptions[sizeName]);
        });
        updateVariant();
      });
    });

    // Expose a setter so the sample-select dropdown can drive the same state.
    window.LE_setOption = function (name, value) {
      selectedOptions[name] = value;
      updateVariant();
      refreshSizePrices();
      if (name === primaryName) broadcastPrimary();
    };

    updateVariant();
    refreshSizePrices();
    broadcastPrimary(); // initial state
  }

  /* ============================================================
     SAMPLE SELECT (searchable dropdown for sample/outlier products)
     ============================================================ */
  function initSampleSelect() {
    var mount = document.getElementById('le-pdp-sample-mount');
    var data = window.LE_PDP;
    if (!mount || !data || !data.sample || !window.LE_sampleSelect) return;
    var optName = data.sample.option;
    var current = null;
    if (data.selectedVariant) {
      data.selectedVariant.selectedOptions.forEach(function (o) { if (o.name === optName) current = o.value; });
    }
    window.LE_sampleSelect(mount, {
      samples: data.sample.values,
      value: current,
      placeholder: 'Select a sample',
      onChange: function (v) { if (window.LE_setOption) window.LE_setOption(optName, v); }
    });
  }

  /* ============================================================
     QUANTITY
     ============================================================ */
  function initQty() {
    var qtyEl = document.getElementById('le-pdp-qty-val');
    var minusBtn = document.getElementById('le-pdp-qty-minus');
    var plusBtn = document.getElementById('le-pdp-qty-plus');
    var qtyInput = document.getElementById('le-pdp-qty-input');
    if (!qtyEl) return;

    var qty = 1;
    function setQty(n) {
      qty = Math.max(1, n);
      qtyEl.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
    }
    if (minusBtn) minusBtn.addEventListener('click', function () { setQty(qty - 1); });
    if (plusBtn) plusBtn.addEventListener('click', function () { setQty(qty + 1); });
  }

  /* ============================================================
     ADD TO CART (AJAX → native Horizon cart drawer)
     ============================================================ */

  // Section-id gathering, drawer opening and the /cart/add.js POST all live in
  // assets/le-cart-add.js (window.LE_addToCart), shared with the merged PDP so
  // there is exactly ONE add-to-cart code path on the storefront. That file is
  // loaded immediately before this one by sections/le-pdp-hero.liquid.
  function addToCart(variantId, qty) {
    if (typeof window.LE_addToCart !== 'function') {
      return Promise.reject(new Error('le-cart-add.js not loaded'));
    }
    return window.LE_addToCart(variantId, qty);
  }

  function initATC() {
    var form = document.getElementById('le-pdp-form');

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var variantId = document.getElementById('le-pdp-variant-id').value;
        var qty = document.getElementById('le-pdp-qty-input').value || 1;
        var btn = form.querySelector('[data-atc-btn]');
        if (btn) { btn.disabled = true; btn.setAttribute('data-loading', 'true'); }
        addToCart(variantId, qty)
          .catch(function (err) { console.error('ATC error', err); })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.removeAttribute('data-loading'); }
          });
      });

      // Sticky bar ATC mirrors the main form's current variant + qty.
      var stickyAtc = document.getElementById('le-pdp-sticky-atc');
      if (stickyAtc) {
        stickyAtc.addEventListener('click', function () {
          var variantId = document.getElementById('le-pdp-variant-id').value;
          var qty = document.getElementById('le-pdp-qty-input').value || 1;
          stickyAtc.disabled = true;
          addToCart(variantId, qty)
            .catch(function (err) { console.error('ATC error', err); })
            .finally(function () { stickyAtc.disabled = false; });
        });
      }
    }

    // Add-on cards: add the chosen size (or the only variant).
    document.querySelectorAll('[data-addon-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.le-pdp-addon-card');
        var sel = card ? card.querySelector('[data-addon-size]') : null;
        var variantId = (sel && sel.value) ? sel.value : btn.dataset.variantId;
        if (!variantId) return;
        btn.disabled = true;
        addToCart(variantId, 1)
          .catch(function (err) { console.error('ATC error', err); })
          .finally(function () { btn.disabled = false; });
      });
    });
  }

  /* ============================================================
     STICKY BAR
     ============================================================ */
  function initStickyBar() {
    var bar = document.getElementById('le-pdp-sticky');
    var anchor = document.getElementById('le-pdp-hero-anchor');
    if (!bar || !anchor) return;

    var visible = false;
    function onScroll() {
      var past = anchor.getBoundingClientRect().bottom < 80;
      if (past !== visible) {
        visible = past;
        bar.classList.toggle('le-pdp-sticky--visible', visible);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ============================================================
     ABOUT PANEL (slide-up)
     ============================================================ */
  function initAboutPanel() {
    var sheet = document.getElementById('le-about-sheet');
    var scrim = document.getElementById('le-pdp-panel-scrim');
    if (!sheet) return;

    var closeTimeout = null;

    function openAbout() {
      if (closeTimeout) { clearTimeout(closeTimeout); closeTimeout = null; }
      sheet.classList.add('le-about-sheet--open');
      if (scrim) scrim.classList.add('le-pdp-panel-scrim--visible');
      // Lock scroll on both html + body (the scroll container varies) so the
      // site behind the blurred scrim stays put until the sheet is closed.
      if (window.LESheetLock) LESheetLock.lock();
    }

    function closeAbout() {
      sheet.classList.remove('le-about-sheet--open');
      if (scrim) scrim.classList.remove('le-pdp-panel-scrim--visible');
      // Release immediately, not after the 470ms close animation: the shared
      // lock restores the exact scroll position, so there is no jump to hide,
      // and a deferred release would drift the reference count if the sheet
      // were reopened mid-animation.
      if (window.LESheetLock) LESheetLock.unlock();
    }

    document.querySelectorAll('[data-open-about]').forEach(function (btn) {
      btn.addEventListener('click', openAbout);
    });
    document.querySelectorAll('[data-close-about]').forEach(function (btn) {
      btn.addEventListener('click', closeAbout);
    });
    if (scrim) scrim.addEventListener('click', closeAbout);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAbout();
    });
  }

  /* ============================================================
     VARIANT SHEET (slide-up for related quick-add)
     ============================================================ */
  function initVariantSheet() {
    var sheet = document.getElementById('le-variant-sheet');
    var scrim = document.getElementById('le-pdp-panel-scrim');
    if (!sheet) return;

    var currentProduct = null;
    var selectedSize = null;
    var closeTimeout = null;

    function openSheet(productHandle, productData) {
      currentProduct = productData;
      if (closeTimeout) { clearTimeout(closeTimeout); closeTimeout = null; }
      // Populate the sheet
      var titleEl = sheet.querySelector('[data-vs-title]');
      var catEl = sheet.querySelector('[data-vs-cat]');
      var imgEl = sheet.querySelector('[data-vs-img]');
      if (titleEl && productData.title) titleEl.textContent = productData.title;
      if (catEl && productData.catLabel) catEl.textContent = productData.catLabel;
      if (imgEl && productData.imgUrl) { imgEl.src = productData.imgUrl; imgEl.alt = productData.title || 'Product image'; }

      // Render size options
      var sizesWrap = sheet.querySelector('[data-vs-sizes]');
      if (sizesWrap && productData.variants) {
        sizesWrap.innerHTML = '';
        productData.variants.forEach(function (v) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'le-vs-size';
          btn.dataset.variantId = v.id;
          btn.innerHTML = '<span class="le-vs-size__label">' + v.title + '</span>' +
            '<span class="le-vs-size__price">' + formatMoney(v.price) + '</span>';
          btn.addEventListener('click', function () {
            sizesWrap.querySelectorAll('.le-vs-size').forEach(function (b) {
              b.classList.remove('le-vs-size--active');
            });
            btn.classList.add('le-vs-size--active');
            selectedSize = v.id;
          });
          sizesWrap.appendChild(btn);
        });
        // Select first
        if (sizesWrap.firstChild) sizesWrap.firstChild.click();
      }

      sheet.classList.add('le-variant-sheet--open');
      if (scrim) scrim.classList.add('le-pdp-panel-scrim--visible');
      if (window.LESheetLock) LESheetLock.lock();
    }

    function closeSheet() {
      sheet.classList.remove('le-variant-sheet--open');
      if (scrim) scrim.classList.remove('le-pdp-panel-scrim--visible');
      // Immediate, for the same reason as closeAbout() above.
      if (window.LESheetLock) LESheetLock.unlock();
    }

    // Expose globally for related cards to call
    window.LE_openVariantSheet = openSheet;
    window.LE_closeVariantSheet = closeSheet;

    var closeBtn = sheet.querySelector('[data-vs-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);
    if (scrim) scrim.addEventListener('click', function () {
      closeSheet();
    });

    var vsAtc = sheet.querySelector('[data-vs-atc]');
    if (vsAtc) {
      vsAtc.addEventListener('click', function () {
        if (!selectedSize) return;
        vsAtc.disabled = true;
        var add = window.LE_addToCart ? window.LE_addToCart(selectedSize, 1) : Promise.resolve();
        add
          .then(function () { closeSheet(); })
          .catch(function (err) { console.error('ATC error', err); })
          .finally(function () { vsAtc.disabled = false; });
      });
    }
  }

  /* ============================================================
     ACCORDIONS
     ============================================================ */
  function initAccordions() {
    document.querySelectorAll('[data-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-acc-item]');
        var body = item.querySelector('[data-acc-body]');
        var arrow = btn.querySelector('[data-acc-arrow]');
        var isOpen = body.classList.contains('le-pdp-acc-body--open');

        // Close all in same group
        var group = item.closest('[data-acc-group]');
        if (group) {
          group.querySelectorAll('[data-acc-body]').forEach(function (b) { b.classList.remove('le-pdp-acc-body--open'); });
          group.querySelectorAll('[data-acc-btn]').forEach(function (b) {
            b.classList.remove('le-pdp-acc-btn--open');
            var a = b.querySelector('[data-acc-arrow]');
            if (a) a.classList.remove('le-pdp-acc-arrow--open');
          });
        }

        if (!isOpen) {
          body.classList.add('le-pdp-acc-body--open');
          btn.classList.add('le-pdp-acc-btn--open');
          if (arrow) arrow.classList.add('le-pdp-acc-arrow--open');
        }
      });
    });
  }

  /* ============================================================
     RELATED PRODUCTS CAROUSEL
     ------------------------------------------------------------
     Deliberately identical to the homepage carousel (sections/lab-best-sellers):
     native overflow-x scrolling + CSS scroll-snap does the work, and the arrows
     are a plain scrollBy that the snap settles onto the next card. Keep the two
     in step — this used to be a bespoke rAF easing with disabled end-states,
     which is why it felt different from the homepage.
     ============================================================ */
  function initRelatedCarousel() {
    var track = document.getElementById('le-rel-track');
    if (!track) return;
    var prevBtn = document.getElementById('le-rel-prev');
    var nextBtn = document.getElementById('le-rel-next');
    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -360, behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: 360, behavior: 'smooth' }); });
  }

  /* ============================================================
     RELATED PRODUCTS — server-rendered from the product's category
     ------------------------------------------------------------
     Previously this fetched the section back from the Recommendations API and
     did `container.innerHTML = inner.innerHTML`. The section never read
     `recommendations.products`, so that response always held zero cards and the
     assignment wiped the server-rendered ones — the row flashed, then emptied.
     The cards are rendered server-side now. The section renders a pool ~3x what
     we show; here we shuffle it and drop the surplus. The pick has to happen
     client-side because Shopify edge-caches the PDP HTML — two refreshes inside
     that window get identical markup, so a server-side random would repeat.
     Degrades safely: with JS off the whole pool just stays in the carousel.
     ============================================================ */
  function initRelatedProducts() {
    var track = document.querySelector('[data-rel-shuffle]');
    if (track) {
      var items = [];
      for (var i = 0; i < track.children.length; i++) items.push(track.children[i]);
      for (var j = items.length - 1; j > 0; j--) {
        var k = Math.floor(Math.random() * (j + 1));
        var tmp = items[j]; items[j] = items[k]; items[k] = tmp;
      }
      var show = parseInt(track.dataset.relShow, 10);
      if (!show || show < 1) show = items.length;
      var frag = document.createDocumentFragment();
      items.forEach(function (el, idx) {
        if (idx < show) frag.appendChild(el);
        else el.remove();
      });
      track.appendChild(frag);

      /* Always open on the first card. Detaching and re-appending the cards
         above makes `scroll-snap-type: x mandatory` re-snap to whichever card
         ends up under the old offset, so the row could open scrolled into the
         middle or the end. Lazy images resolving later shift it again, and the
         browser restores the previous offset on a back-nav — so reset now, once
         more after load, and pin the first card as the snap target. */
      var reset = function () { track.scrollLeft = 0; };
      reset();
      if (track.firstElementChild) track.firstElementChild.style.scrollSnapAlign = 'start';
      requestAnimationFrame(reset);
      window.addEventListener('load', reset, { once: true });
    }
    initRelatedCarousel();
    initVariantSheetCards();
  }

  function initVariantSheetCards() {
    document.querySelectorAll('[data-rel-atc]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('[data-rel-card]');
        if (!card) return;
        var productData = {
          title: card.dataset.title,
          catLabel: card.dataset.catLabel,
          imgUrl: card.dataset.imgUrl,
          variants: JSON.parse(card.dataset.variants || '[]')
        };
        if (window.LE_openVariantSheet) {
          window.LE_openVariantSheet(card.dataset.handle, productData);
        }
      });
    });
  }

  /* ============================================================
     STICKY SIZE DROPUP
     ============================================================ */
  function initStickyDropup() {
    var trigger = document.getElementById('le-sticky-size-trigger');
    var dropup = document.getElementById('le-sticky-dropup');
    if (!trigger || !dropup) return;

    function openDropup() {
      dropup.classList.add('le-sticky-dropup--open');
      dropup.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closeDropup() {
      dropup.classList.remove('le-sticky-dropup--open');
      dropup.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (dropup.classList.contains('le-sticky-dropup--open')) {
        closeDropup();
      } else {
        openDropup();
      }
    });

    document.addEventListener('click', function (e) {
      if (!dropup.contains(e.target) && e.target !== trigger) {
        closeDropup();
      }
    });

    // Close dropup after size selection
    dropup.querySelectorAll('[data-size-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeDropup();
      });
    });
  }

  /* ============================================================
     REVIEWS SCROLL ANCHOR
     ============================================================ */
  function initReviewsAnchor() {
    document.querySelectorAll('[data-scroll-reviews]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById('le-pdp-reviews');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
    // Generic version: [data-scroll-to="element-id"]. Used by the kit buy-box
    // link. Falls back to the plain #hash jump if the target isn't on the page.
    document.querySelectorAll('[data-scroll-to]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var target = document.getElementById(btn.getAttribute('data-scroll-to'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ============================================================
     MONEY FORMATTER
     ============================================================ */
  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var dollars = cents / 100;
    return '$' + dollars.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ============================================================
     UNIT PRICE  ("$1.81 per ml")
     Parse the variant's size option value (whole value = number + ml/g,
     e.g. "30ml", "5g", "2.5 ml"). Hide the line if there's no ml/g unit.
     ============================================================ */
  function updatePerUnit(variant) {
    var noteEl = document.getElementById('le-pdp-perunit');
    if (!noteEl) return;
    var amount = 0, unit = '';
    if (variant && variant.selectedOptions) {
      for (var i = 0; i < variant.selectedOptions.length; i++) {
        var m = /^\s*([\d.]+)\s*(ml|g)\s*$/i.exec(String(variant.selectedOptions[i].value));
        if (m) { amount = parseFloat(m[1]); unit = m[2].toLowerCase(); break; }
      }
    }
    if (variant && amount > 0 && unit) {
      noteEl.innerHTML = '<strong>' + formatMoney(Math.round(variant.price / amount)) + '</strong> per ' + unit;
      noteEl.style.display = '';
    } else {
      noteEl.style.display = 'none';
    }
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    initGallery();
    initVariantSelector();
    initSampleSelect();
    initQty();
    initATC();
    initStickyBar();
    initStickyDropup();
    initAboutPanel();
    initVariantSheet();
    initAccordions();
    initRelatedProducts();
    initReviewsAnchor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
